var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBasiliskLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9048_133190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 2.63192e-08C19.1637 -0.000181444 22.2572 0.93807 24.8885 2.6961C27.5199 4.45413 29.5708 6.95299 30.7819 9.87664C31.993 12.8003 32.3099 16.0174 31.6926 19.1212C31.0753 22.225 29.5514 25.076 27.3137 27.3137C25.076 29.5514 22.225 31.0753 19.1212 31.6926C16.0174 32.3099 12.8003 31.993 9.87664 30.7819C6.95298 29.5708 4.45414 27.5199 2.6961 24.8885C0.93807 22.2572 -0.000181444 19.1637 2.63192e-08 15.9991C2.63192e-08 13.898 0.413832 11.8176 1.21786 9.8765C2.02189 7.9354 3.20037 6.17167 4.68602 4.68602C6.17167 3.20037 7.9354 2.02189 9.8765 1.21786C11.8176 0.413828 13.898 2.63192e-08 15.9991 2.63192e-08ZM10.7792 15.9991C10.7792 23.7312 15.9991 29.9988 15.9991 29.9988C15.9991 29.9988 21.2189 23.7312 21.2189 15.9991C21.2189 8.267 15.9991 2.00023 15.9991 2.00023C15.9991 2.00023 10.7792 8.26792 10.7792 15.9991Z",
    fill: "#4FFFB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9048_133190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasiliskLogoSmall);
export default __webpack_public_path__ + "static/media/BasiliskLogoSmall.1d60baab3e4ed065f6fbf2a1912b7d34.svg";
export { ForwardRef as ReactComponent };